<h3 *ngIf="model && model.heading" data-test="gsm-info_heading">
  <mat-icon *ngIf="model.icon" class="info-icon" data-test="gsm-info_icon">{{ model.icon }}</mat-icon>
  {{ model.heading }}
</h3>
<p [ngClass]="{ 'instruction-text': model.isInstruction }" [innerHTML]="content"></p>
